import { createAsyncThunk } from "@reduxjs/toolkit";

import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";
import { aboutApi } from "service/aboutApi";

export const getAbout = createAsyncThunk(
  "getAbout",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await aboutApi.getAbout();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateAbout = createAsyncThunk(
  "updateAbout",
  async ({ data, media1File, media2File }, { rejectWithValue, dispatch }) => {
    try {
      const { data: response } = await aboutApi.updateAbout(data, media1File, media2File);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      dispatch(getAbout());
      return response;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);
